<template>
  <div class="moniadd">
    <moduler name="targetingadd" title="新增定向包">
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">媒体</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="targeting.mediaId" type="button">
            <Radio :label="16" disabled>腾讯</Radio>
            <Radio :label="32" disabled>磁力引擎</Radio>
            <Radio :label="6" disabled>超级汇川</Radio>
            <Radio :label="45">百度信息流</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">定向包名称</span>
        </Col>
        <Col span="12">
          <input-len v-model="targeting.targetingName" placeholder="最大30个字符，1个中文等于2个字符" :max="30" width="352" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">描述</span>
        </Col>
        <Col span="12">
          <textarea-len v-model="targeting.targetingDesc" placeholder="最大300个字符，1个中文等于2个字符" :max="300" width="352" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">账号选择</span>
        </Col>
        <Col span="12">
          <auto-complete
            :data="accountData"
            v-model="targeting.accountIds"
            placeholder="请选择账号"
            @on-select="handleAccount"
            style="width: 280px"
          />
        </Col>
      </Row>

      <!-- 人群包 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">人群包</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.audienceMode" type="button" @on-change="changeRetarget">
            <Radio label="NONE">不限</Radio>
            <Radio label="AUDIENCE">定向与排除</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.audienceMode === 'AUDIENCE'">
        <Col span="3">&nbsp;</Col>
        <Col span="18">
          <retarget title="选定人群" :data="target.audienceData" :use-word="disCrowd" @on-clear="clearRetarget" @on-delete="delRetarget" />
        </Col>
      </Row>
      <!-- 地域 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">地域</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.district" type="button" @on-change="radioChange('cityData')">
            <Radio label="NONE">不限</Radio>
            <Radio label="CITY">按省市</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-show="target.district === 'CITY'">
        <Col span="3">&nbsp;</Col>
        <Col span="14">
          <selecter
            v-model="mult_city"
            :data="target.cityData"
            :title="['省份', '城市']"
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="clearTag"
          />
        </Col>
      </Row>

      <!-- 性别 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">性别</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.sex" type="button">
            <Radio label="0">不限</Radio>
            <Radio label="2">男</Radio>
            <Radio label="1">女</Radio>
          </RadioGroup>
        </Col>
      </Row>

      <!-- 年龄 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">年龄</span>
        </Col>
        <Col span="18">
          <RadioGroup v-model="target.ageMode" type="button" @on-change="changeAge">
            <Radio label="NONE">不限</Radio>
            <Radio label="RANGE">指定年龄段</Radio>
            <Radio label="CUSTOM">自定义年龄</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.ageMode === 'RANGE'">
        <Col span="3" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="18" class="col-flex">
          <CheckboxGroup v-model="target.age">
            <Checkbox label="1">18岁以下</Checkbox>
            <Checkbox label="2">18-24岁</Checkbox>
            <Checkbox label="3">25-34岁</Checkbox>
            <Checkbox label="4">35-44岁</Checkbox>
            <Checkbox label="5">45-54岁</Checkbox>
            <Checkbox label="6">54岁以上</Checkbox>
          </CheckboxGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.ageMode === 'CUSTOM'">
        <Col span="3" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="18">
          <range-age v-model="target.customAge" :offset="9" />
        </Col>
      </Row>
      <!-- 兴趣 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">兴趣</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.interestType" type="button" @on-change="radioChange('interestData')">
            <Radio label="NONE">不限</Radio>
            <Radio label="CUSTOM" :disabled="useCrowd">按兴趣分类</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.interestType === 'CUSTOM'">
        <Col span="3" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="18">
          <selecter
            v-model="mult_interest"
            :data="target.interestData"
            :title="['可选兴趣']"
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="clearTag"
          />
        </Col>
      </Row>

      <!-- 意向 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">意图词</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.keywordsType" type="button" @on-change="changeKeyword">
            <Radio label="NONE">不限</Radio>
            <Radio label="ADD" :disabled="useCrowd">添加意图词</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <template v-if="target.keywordsType === 'ADD'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="20">
            <keyword-interest
              v-model="target.keywords"
              :account="targeting.accountIds"
              @on-select="appendMultword"
              @on-delete="deleteMultWord"
              @on-clear="$set(target, 'keywords', [])"
            />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="1" style="margin-right: 12px">&nbsp;</Col>
          <Col span="3" class="col-item">
            <span class="item-field">用户行为</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="target.keywordsExtend" type="button">
              <Radio label="1">全网行为</Radio>
              <Radio label="2">历史搜索</Radio>
            </RadioGroup>
          </Col>
        </Row>
      </template>

      <!-- APP定向 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">APP定向</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.appType" type="button" @on-change="changeAppType">
            <Radio label="all">不限</Radio>
            <Radio label="category">APP分类</Radio>
            <Radio label="custom">按APP名称</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.appType !== 'all'">
        <Col span="3" class="col-item">
          <span class="item-field">定向逻辑</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.appBehavior" type="button">
            <Radio :label="2">安装</Radio>
            <Radio :label="4">排除安装</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.appType === 'category'">
        <Col span="3" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="20">
          <selecter
            v-model="mult_gategory"
            :data="target.gategoryData"
            :title="['按APP分类']"
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="clearTag"
          />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.appType === 'custom'">
        <Col span="3">&nbsp;</Col>
        <Col span="17">
          <adder v-model="target.mult_app" :account="targeting.accountIds" placeholder="请输入APP名称" />
        </Col>
      </Row>

      <!-- 操作系统 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">操作系统</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.device" type="button" @on-change="changePlatform">
            <Radio label="0">不限</Radio>
            <Radio label="1">iOS</Radio>
            <Radio label="2">Android</Radio>
          </RadioGroup>
        </Col>
      </Row>

      <!-- iOS版本 -->
      <Row class="row-item" :gutter="12" v-if="target.device === '1'">
        <Col span="3" class="col-item">
          <span class="item-field">iOS版本</span>
        </Col>
        <Col span="18">
          <Mixcheck v-model="target.iosVersion">
            <radio-item label="0">不限</radio-item>
            <check-item v-for="item in ios_version" :label="item.key" :key="item.key">
              {{ item.label }}
            </check-item>
          </Mixcheck>
        </Col>
      </Row>

      <!-- 安卓版本 -->
      <Row class="row-item" :gutter="12" v-if="target.device === '2'">
        <Col span="3" class="col-item">
          <span class="item-field">安卓版本</span>
        </Col>
        <Col span="18">
          <Mixcheck v-model="target.androidVersion">
            <radio-item label="0">不限</radio-item>
            <check-item v-for="item in android_version" :label="item.key" :key="item.key">
              {{ item.label }}
            </check-item>
          </Mixcheck>
        </Col>
      </Row>

      <!-- 网络 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">网络</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.net" type="button">
            <Radio label="0">不限</Radio>
            <Radio label="1">WIFI</Radio>
            <Radio label="2">移动网络</Radio>
          </RadioGroup>
        </Col>
      </Row>

      <!-- 人生阶段 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">人生阶段</span>
        </Col>
        <Col span="12">
          <Mixcheck v-model="target.lifeStage" type="button">
            <radio-item label="0">不限</radio-item>
            <check-item label="1">未婚</check-item>
            <check-item label="2">已婚</check-item>
            <check-item label="3">孕期</check-item>
            <check-item label="4">家有儿女</check-item>
          </Mixcheck>
        </Col>
      </Row>

      <!-- 学历 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">学历</span>
        </Col>
        <Col span="12">
          <Mixcheck v-model="target.education" type="button">
            <radio-item label="0">不限</radio-item>
            <check-item label="1">大学及以上</check-item>
            <check-item label="2">高中及以下</check-item>
            <check-item label="3">大专</check-item>
          </Mixcheck>
        </Col>
      </Row>

      <!-- 智能扩量 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">智能扩量</span>
        </Col>
        <Col span="12" class="col-flex">
          <i-Switch v-model="target.autoExpansion" true-value="1" false-value="0" />
        </Col>
      </Row>

      <!-- 排除已转化用户 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">排除已转化用户</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.excludeTrans" type="button">
            <Radio label="0">不限</Radio>
            <Radio label="3">同单元</Radio>
            <Radio label="2">同计划</Radio>
            <Radio label="1">同账户</Radio>
          </RadioGroup>
        </Col>
      </Row>
    </moduler>

    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="save">
            <span v-if="!loading">更新</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit">
            <span v-if="!loading">提交</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import validMixin from './mixins/valid-mixin'
// import addxin from '@/views/create/baidu/components/adder-mixin'
import { isArray, findCheck, getNameOfData, clearTagOfData, timeout, isEmpty } from '@/common/js/utils'
import { android_version, ios_version } from '@/data/baidu/ad_target_data.js'
import cityData from '@/data/baidu/city_province'
import gategoryData from '@/data/baidu/app_categroy'
import newInterestData from '@/data/baidu/new_interests'

import Moduler from '@/components/moduler.vue'
import InputLen from '@/components/input/input-len.vue'
import TextareaLen from '@/components/input/textarea-len.vue'
import AutoComplete from '@/components/autocomplete/autocomplete'
import Selecter from '@/components/select/selecter.vue'
import RangeAge from '@/components/range/baidu-age.vue'
import Retarget from '@/views/create/baidu/components/retarget'
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'
import Adder from '@/views/create/baidu/components/add/adder'
import ErrorPop from '@/components/error-pop.vue'
import KeywordInterest from '@/views/create/baidu_local/components/keywordinterest/'

import { adAccount } from '@/api/common.model'
import { getAudience } from '@/api/baidu.model'
import { addTargeting, updateTargeting, getTargetingDataById } from '@/api/manage.model'

export default {
  components: {
    Moduler,
    InputLen,
    TextareaLen,
    AutoComplete,
    Selecter,
    RangeAge,
    Retarget,
    Mixcheck,
    CheckItem,
    RadioItem,
    Adder,
    ErrorPop,
    KeywordInterest
  },
  name: 'BdTarget',
  mixins: [validMixin],
  data() {
    return {
      targeting: {
        mediaId: 45,
        targetingId: this.$route.query.targetingId,
        accountIds: '',
        targetingName: '',
        targetingDesc: ''
      },
      target: {
        district: 'NONE',
        region: [],
        sex: '0',
        ageMode: 'NONE',
        age: '0',
        customAge: '0',
        audienceMode: 'NONE',
        audienceData: [],
        crowd: [],
        excludeCrowd: [],
        keywordsType: 'NONE',
        keywordsExtend: '1', // 意图词用户行为
        interestType: 'NONE',
        newInterests: [],
        keywords: [],
        appType: 'all',
        appBehavior: 2,
        device: '0',
        androidVersion: '0',
        iosVersion: '0',
        net: '0',
        lifeStage: '0',
        education: '0',
        mult_app: [],
        app: [],
        autoExpansion: '0',
        excludeTrans: '0',

        // 数据源
        cityData: cityData,
        gategoryData: gategoryData,
        interestData: newInterestData,
        appData: []
      },

      accountData: [], // 账号下拉数据
      android_version: android_version,
      ios_version: ios_version,
      account: this.$store.state.Baidulocal.accountId,
      cating: false,
      show: null,
      loading: null,
      formErr: null, // 表单检验状态
      errRes: [] // 错误的数值
    }
  },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    useCrowd() {
      return this.target.audienceData.some((ret) => ret.select === 'include')
    },
    disCrowd() {
      const isUseWord = this.target.keywordsType === 'ADD'
      const isUseIntrest = this.target.interestType === 'CUSTOM'
      return isUseWord || isUseIntrest
    },
    mult_city() {
      return findCheck(this.target.cityData)
    },
    mult_interest() {
      return findCheck(this.target.interestData)
    },
    mult_gategory() {
      return findCheck(this.target.gategoryData)
    }
  },
  watch: {
    'target.appType': {
      handler(nVal) {
        if (nVal === 'all') {
          this.radioChange('gategoryData')
          this.mult_app = []
        } else if (nVal === 'custom') this.radioChange('gategoryData')
        else this.mult_app = []
      }
    },
    mult_city(nVal) {
      if (isArray(nVal)) {
        this.target.region = nVal.map((ret) => ret.id)
      }
    },
    mult_gategory(nVal) {
      if (isArray(nVal)) {
        this.target.app = nVal.map((ret) => ret.id)
      }
    },
    mult_interest(nVal) {
      if (isArray(nVal)) {
        this.target.newInterests = nVal.map((ret) => ret.id)
      }
    },
    'target.audienceData': {
      handler(nVal) {
        if (isArray(nVal)) {
          const getId = (item) => item.id
          this.target.crowd = nVal.filter((ret) => ret.select === 'include').map(getId)
          this.target.excludeCrowd = nVal.filter((ret) => ret.select === 'exclude').map(getId)
        }
      },
      deep: true
    }
  },
  methods: {
    getData() {
      // 加载动画
      this.show = false
      this.$Spin.show()
      getTargetingDataById({
        targetingId: this.targeting.targetingId
      })
        .then((data) => {
          if (data) {
            const { targetingId, targetingName, targetingDesc, targetingParamJson: target, accountIds } = data
            this.targeting = Object.assign({}, this.targeting, {
              targetingId,
              targetingName,
              targetingDesc,
              accountIds: Number(accountIds)
            })
            if (target) {
              Object.assign(this.target, target)
            }
            timeout(2000).then(() => {
              this.show = true
              this.$Spin.hide()
            })
          }
        })
        .catch((err) => {
          console.log(err)
          this.$Message.error(err)
        })
    },
    preloadData() {
      const { accountIds: accountId } = this.targeting
      // 查人群包
      const param = { ad_account_id: accountId }
      this.$Spin.show()
      Promise.all([getAudience(param)]).then((data) => {
        this.$Spin.hide()
        const [audienceData] = data
        if (isArray(audienceData)) {
          this.target.audienceData = audienceData
            .filter((ret) => ret.groupStatus === 'finished')
            .map((ret) => {
              return {
                id: ret.groupId,
                name: ret.groupName,
                type: ret.groupTypeDesc
              }
            })
        }
      })
    },
    handleAccount(meta) {
      this.$set(this.targeting, 'accountIds', meta.id)
      this.preloadData()
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      if (current) {
        const item = getNameOfData(list, current)
        data = item.children
      } else data = list
      // 递归选中
      const deepSelectAll = (items) => {
        items.some((ret) => {
          if (ret.children && ret.children.length) deepSelectAll(ret.children)
          this.$set(ret, 'check', check)
        })
      }
      deepSelectAll(data)
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    },
    radioChange(key) {
      clearTagOfData(this.target[key], this)
    },
    // 定向人群切换
    changeRetarget(val) {
      if (val === 'NONE') {
        this.target.audienceData.forEach((met) => {
          this.$set(met, 'select', '')
        })
      }
    },
    // 清空人群包
    clearRetarget({ list }) {
      list.forEach((item) => {
        this.$set(item, 'select', null)
      })
    },
    delRetarget({ list, name }) {
      const index = list.findIndex((ret) => ret.name === name)
      if (index > -1) {
        this.$set(list[index], 'select', null)
      }
    },
    appendMultword(vals) {
      this.target.keywords.push(...vals)
    },
    deleteMultWord(val) {
      if (!val) return
      const idx = this.target.keywords.indexOf(val)
      this.target.keywords.splice(idx, 1)
    },
    changePlatform() {
      this.$set(this.target, 'iosVersion', '0')
      this.$set(this.target, 'androidVersion', '0')
    },
    changeAge(val) {
      if (val === 'RANGE') {
        this.target.age = ['1']
        this.target.customAge = '0'
      } else if (val === 'CUSTOM') {
        this.target.age = '0'
        this.target.customAge = [18, 55]
      } else {
        this.target.age = '0'
        this.target.customAge = '0'
      }
    },
    changeKeyword(val) {
      let keywordsExtend, keywords
      if (val === 'ADD') {
        keywordsExtend = '1'
        keywords = []
      }
      this.$set(this.target, 'keywordsExtend', keywordsExtend)
      this.$set(this.target, 'keywords', keywords)
    },
    changeAppType() {
      this.radioChange('gategoryData')
      this.$set(this.target, 'mult_app', [])
      this.$set(this.target, 'app', [])
    },
    valid() {
      const rules = [
        {
          name: 'targeting/targetingName',
          require: true,
          min: 1,
          max: 30,
          desc: '定向包名称'
        },
        {
          name: 'mult_city',
          require: true,
          relyon: 'target/district',
          relyvalue: 'CITY',
          min: 1,
          desc: '地域'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    customValid() {
      const err = []
      const includes = this.target.audienceData.filter((ret) => ret.select === 'include')
      const excludes = this.target.audienceData.filter((ret) => ret.select === 'exclude')
      // 人群包
      if (this.target.audienceMode === 'AUDIENCE' && !includes.length && !excludes.length) {
        err.push({ feild: '人群包', msg: '请选择人群包，或是切换成不限' })
      }
      // 账号
      if ((includes.length || excludes.length) && isEmpty(this.targeting.accountIds)) {
        err.push({ feild: '人群包', msg: '账号不能为空' })
      }
      // 年龄
      if (this.target.ageMode === 'RANGE') {
        if (!this.target.age || !this.target.age.length) {
          err.push({ feild: '年龄', msg: '请选择年龄段或切换为不限' })
        }
      }
      // 兴趣
      if (this.target.interestType === 'CUSTOM') {
        if (!this.mult_interest || !this.mult_interest.length) {
          err.push({ feild: '兴趣', msg: '请选择兴趣或切换为不限' })
        }
      }
      // 意图词
      if (this.target.keywordsType === 'ADD') {
        if (!this.target.keywords || !this.target.keywords.length) {
          err.push({ feild: '兴趣', msg: '请选择意图词或切换为不限' })
        }
      }
      // APP定向-按APP名称
      if (this.target.appType === 'custom') {
        if (!this.target.mult_app.length) {
          err.push({ feild: 'APP定向', msg: '请选择APP名称，或是切换成不限' })
        }
      }
      // APP定向-按APP分类
      if (this.target.appType === 'category') {
        if (!this.mult_gategory.length) {
          err.push({ feild: 'APP定向', msg: '请选择APP分类，或是切换成不限' })
        }
      }
      return err
    },
    save() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const target = JSON.parse(JSON.stringify(this.target))
      delete target.mult_gategory
      // 组合提交参数
      const params = Object.assign({}, this.targeting, {
        targetingParamJson: target,
        targetingParam: JSON.stringify(target),
        accountIds: String(this.targeting.accountIds)
      })

      this.$Spin.show()
      this.loading = true
      updateTargeting(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 1.5,
            content: '修改成功！2秒后自动跳转'
          })
          timeout(2000).then(() => {
            this.jump()
          })
        }
      })
    },
    submit() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const target = JSON.parse(JSON.stringify(this.target))
      // 组合提交参数
      const params = Object.assign({}, this.targeting, {
        targetingParamJson: target,
        targetingParam: JSON.stringify(target),
        accountIds: String(this.targeting.accountIds)
      })
      this.$Spin.show()
      this.loading = true
      addTargeting(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 1.5,
            content: '提交成功！2秒后自动跳转'
          })
          timeout(2000).then(() => {
            this.jump()
          })
        }
      })
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.jump()
        }
      })
    },
    jump() {
      this.$router.push({ name: 'targetingslist' })
    }
  },
  created() {
    adAccount({
      mediaId: this.targeting.mediaId,
      authFlag: 1
    })
      .then((data) => {
        if (isArray(data) && data.length) {
          this.accountData = data.map((ret, id) => {
            if (!id) this.targeting.accountIds = Number(ret.id)
            return { id: ret.id, name: ret.name }
          })
          if (this.targeting.targetingId) this.getData()
          else this.preloadData()
        }
      })
      .catch((err) => {
        this.$Message.error('获取账号接口报错：' + err)
      })
  }
}
</script>

<style lang="scss" scoped>
.moniadd {
  height: calc(100% - 40px);
  overflow: auto;

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

/* 单选框覆盖 */
.ivu-radio-wrapper {
  min-width: 94px;
  text-align: center;
  user-select: none;
}

.ivu-tabs-bar {
  margin-bottom: 0;
}

/* 表单选项 */
.row-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 32px;

  .col-item {
    text-align: right;
  }

  i {
    margin-right: 4px;
    vertical-align: middle;

    &.ivu-icon-md-add {
      margin: 0;
    }
  }

  .item-field {
    font-size: 14px;
    padding-right: 12px;
    line-height: 32px;
  }

  /* 必填项 */
  .row-item-must {
    position: relative;
    z-index: 5;

    &:after {
      content: ' ';
      display: inline-block;
      width: 4px;
      height: 4px;
      position: absolute;
      top: 6px;
      right: 0;
      background-color: #f45858;
      border-radius: 3px;
    }
  }
}
</style>
